import { render, staticRenderFns } from "./RiskAnalysisReport.vue?vue&type=template&id=1b6d69ec&"
import script from "./RiskAnalysisReport.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports